<template>
  <li v-if="this.item.shouldNotChangeRoute" v-bind:class="itemClasses" :data-action="item.action"  v-on:click="onClick">
    <div class="clickable" v-if="allowedAccess" v-bind:to="{ name: item.name }">
      <i class="icon" v-if="item.icon">{{item.icon}}</i>
      <div v-if="this.item.label">{{ this.item.label }} </div>
      <div v-else-if="this.item.title">{{ this.item.title }} </div>
      <div v-else>{{ $t(`ui.menu.${item.name}`) }}</div>
    </div>

    <navigation-locked-item v-else :item="item"></navigation-locked-item>
  </li>

  <span v-else v-bind:class="itemClasses" :data-action="item.action"  v-on:click="onClick">
    <router-link v-if="allowedAccess" v-bind:to="{ name: item.name }">
      <i class="icon" v-if="item.icon">{{item.icon}}</i>
      <div v-if="this.item.title">{{ this.item.title }} </div>
      <div v-else>{{ $t(`ui.menu.${item.name}`) }}</div>
    </router-link>

    <navigation-locked-item v-else :item="item"></navigation-locked-item>
  </span>
</template>
<script>
import NavigationLockedItem from '@/components/layouts/partials/NavigationLockedItem.vue'
import Permissions from '@/classes/Permission'

export default{
  name: 'folded-navigation-item',
  props: ['item', 'parentWidth'],
  components: {
    NavigationLockedItem
  },
  computed: {
    itemClasses(){
      let classes = ['folded-navigation-item', this.item.name]
      if(this.overflow === true){
        classes.push('is-hidden')
      }
      if(this.item.shouldNotChangeRoute && this.isActive){
        classes.push('is-active')
      }
      return classes
    },
    activeTab() {
      return this.$store.getters.getActiveTab
    },
    isActive: function(){
      if (this.item.name && this.activeTab === this.item.name) {
        return true
      } else if(this.$route.name === this.item.name){
        return true
      }else{
        return false
      }
    },
    allowedAccess() {
      if (this.item.access) {
        return Permissions.planCan(this.item.access)
      } else {
        return true
      }
    }
  },
  data() {
    return {
      overflow: false
    }
  },
  methods: {
    calculateNavigation(){
      this.overflow = false

      let element = this.$el
      let width = element.clientWidth
      let left = element.offsetLeft

      if((this.parentWidth) < (width + left + 10) || (width + left + 10) === 10){
        this.overflow = true
        this.$store.commit('ADD_FOLDED_NAVIGATION_HIDDEN_ITEMS', this.item)
      }else{
        this.overflow = false
      }
    },
    // we want to clean the pagination from the leads when we click on folded navigation
    onClick() {
      if (this.item.name === 'project_leads' && this.$route.name == "project_leads") {
        this.$store.commit('RESET_CURRENT_PAGE_LEADS')
      }else if(this.item.name === "external_forms" && this.$route.name == "external_forms"){
        this.$store.commit('RESET_CURRENT_PAGE_EXTERNAL_FORMS')
      }

      if (this.item.shouldNotChangeRoute) {
        this.$store.commit('SET_ACTIVE_TAB', this.item.name)
      }
    }
  }
}
</script>
<style lang="scss">
.yule-icon-lock {
  font-size: 15px;
}

.folded-navigation-item {
  font-size: 13px;
  margin-right: 20px;
  white-space: nowrap;
  font-weight: 200;

  @include respond-to('large-up'){
    margin-right: 56px;
    font-size: 15px;
  }

  &.is-hidden{
    display: none;
  }

  .router-link-active {
    border-bottom: 2px solid #1B88FD;
    color: $ink;
  }
}

.folded-navigation-item {
  li, a {
    color: inherit;
    display: inline-block;
    text-decoration: none;
    height: 100%;
    border-bottom: 2px solid transparent;
    padding: 0 10px;

    .icon{
      vertical-align: text-bottom;
      margin-right: 0.2em;
      font-size: 20px;
    }
  }
}

.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// FoldedNavigationItem.vue?727c6d9e